import React from 'react';

import FallbackSpinner from '../../components/loader/FallbackSpinner';
import createRouteLoadable from './createRouteLoadable';

export const CHECKOUT_THANK_YOU_CHUNK_NAME = 'checkout';

export const ThankYouPage = createRouteLoadable(
  () => import(/* webpackChunkName: "checkout" */ '../../pages/ThankYouPage'),
  {
    fallback: <FallbackSpinner />,
  }
);
